import { render } from "./add-user-id-to-face-template-modal.vue?vue&type=template&id=765eff00&scoped=true"
import script from "./add-user-id-to-face-template-modal.vue?vue&type=script&lang=js"
export * from "./add-user-id-to-face-template-modal.vue?vue&type=script&lang=js"

import "./add-user-id-to-face-template-modal.vue?vue&type=style&index=0&id=765eff00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765eff00"]])

export default __exports__